import { Dialog, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PropTypes } from 'prop-types';
import SmartPTFullTable from './SmartPTFullTable';
import { useIdleTimer } from 'react-idle-timer'
function SmartPTDialog({initialSuggestedTime, open, onClose, timePeriod}) {

  const handleOnIdle = async () => {
    console.log('User is idle');
    onClose();
  };

  useIdleTimer({
    timeout: (1000 * 30),  //30 seconds to close the modal
    onIdle: handleOnIdle,
    debounce: 500
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="smartPTDialog-title"
      aria-describedby="smartPTDialog-description"
      scroll='paper'
      maxWidth='md'
      fullWidth={true}
    >

      <Divider className='border-yellow border-4'/>

      <DialogTitle id="smartPTDialog-title" className='flex justify-between items-center text-base uppercase font-extrabold'>
        Suggested promise time ({timePeriod})
        <IconButton 
          aria-label='close modal'
          onClick={onClose}
        >
          <CloseIcon className='p-0'/>
        </IconButton>
      </DialogTitle>

      <Divider className='mx-5'/>

      <DialogContent className='flex w-100 justify-around mb-5'>
        <SmartPTFullTable
          label='Waiting'
          amountOfServices={5}
          initialSuggestedTime={initialSuggestedTime?.waiting}
          numberOfBays={10}
        />
        <SmartPTFullTable
          label='Drop off'
          amountOfServices={5}
          initialSuggestedTime={initialSuggestedTime?.dropOff}
          numberOfBays={10}
        />
      </DialogContent>

    </Dialog>
  )
}

SmartPTDialog.propTypes = {
  initialSuggestedTime: PropTypes.shape({
    waiting: PropTypes.array,
    dropOff: PropTypes.array
  }),
  numberOfVehicles: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default SmartPTDialog;